import React from 'react';
import { Card } from 'react-bootstrap';
import Image from 'next/image';

const IMG_HOURS_OF_OPP: string = '/static/images/hours.svg';

interface HourItem {
    day_of_week: string
    open_time_label?: string
    close_time_label?: string
    all_hours?: boolean
    no_hours?: boolean
}

interface FacilityHoursCardProps {
    hours: HourItem[]
}

const FacilityHoursCard: React.FC<FacilityHoursCardProps> = ({ hours }) => {
    if (!hours || hours.filter(hour => hour.day_of_week).length === 0) {
        return null;
    }

    return (
        <Card className="mb-3">
            <Card.Body className="d-flex flex-column align-items-center">
                <Card.Title className="text-center">
                    <Image src={IMG_HOURS_OF_OPP} alt="Hours" width={100} height={100} />
                    <h4><strong>Hours of Operation</strong></h4>
                </Card.Title>
                <div>
                    {hours.map((day, index) => {
                        let output_time = `${day.open_time_label} to ${day.close_time_label}`;
                        let special = false;

                        if (day.all_hours) {
                            output_time = 'Open 24 Hours';
                            special = true;
                        } else if (day.no_hours) {
                            output_time = 'Closed All Day';
                            special = true;
                        }

                        if (!special && (!day.open_time_label && !day.close_time_label)) {
                            return null;
                        }

                        return (
                            <span key={index}>
                                {day.day_of_week}
                                :
                                {' '}
                                {output_time}
                                <br/>
                            </span>
                        );
                    })}
                </div>
            </Card.Body>
        </Card>
    );
};

export default FacilityHoursCard;